import serviceRequest from "utils/request";

const baseUrl = "/project";

export const getProjectListByUser = (param) => {
	return serviceRequest({
		url: `${baseUrl}/get-by-user-profile-id?userProfileId=${param.userProfileId}`,
		method: "get",
	});
};

export const getExpertProjectList = (param) => {
	return serviceRequest({
		url: `${baseUrl}/query-available-expert-projects?userProfileId=${param.userProfileId}`,
		method: "get",
	});
};

export const addUserToExpertProject = (param) => {
	return serviceRequest({
		url: `${baseUrl}/add-user-to-expert-project`,
		method: "post",
		data: param,
	});
};

export const deleteUserToExpertProject = (param) => {
	return serviceRequest({
		url: `${baseUrl}/delete-user-to-expert-project`,
		method: "post",
		data: param,
	});
};

export const getProjectList = (param) => {
	return serviceRequest({
		url: `${baseUrl}/get-project-list`,
		method: "post",
		data: param,
	});
};

export const viewProjectData = (param) => {
	return serviceRequest({
		url: `${baseUrl}/v2/view-project-data`,
		method: "post",
		data: param,
	});
};

export const addProject = (param) => {
	return serviceRequest({
		url: `${baseUrl}/add`,
		method: "post",
		data: param,
	});
};

export const updateProject = (param) => {
	return serviceRequest({
		url: `${baseUrl}/edit`,
		method: "post",
		data: param,
	});
};

export const submitProject = (param) => {
	return serviceRequest({
		url: `${baseUrl}/submit?applicationId=${param.applicationId}`,
		method: "get",
	});
};

export const changeProject = (param) => {
	return serviceRequest({
		url: `${baseUrl}/status/change`,
		method: "post",
		data: param,
	});
};

export const getProjectDetail = (param) => {
	return serviceRequest({
		url: `${baseUrl}/detail?projectId=${param.projectId}`,
		method: "get",
	});
};

export const viewProgressProject = (param) => {
	return serviceRequest({
		url: `${baseUrl}/view-progress`,
		method: "post",
		data: param,
	});
};

export const batchUpdateProject = (param) => {
	return serviceRequest({
		url: `${baseUrl}/batch/update`,
		method: "post",
		data: param,
	});
};

export const getEXPERTProjectDetail = (params) => {
	return serviceRequest({
		url: `${baseUrl}/expert/detail`,
		method: "get",
		params,
	});
};

export const getEXPERTProjectMembers = (params) => {
	return serviceRequest({
		url: `${baseUrl}/expert/get-expert-project-members`,
		method: "get",
		params,
	});
};

export const updateEXPERTProjectMembers = (data) => {
	return serviceRequest({
		url: `${baseUrl}/expert/update-members`,
		method: "post",
		data,
	});
};

export const submitInvitation = (data) => {
	return serviceRequest({
		url: `${baseUrl}/expert/submit-invitation`,
		method: "post",
		data,
	});
};

export const changeInvitationStatus = (data) => {
	return serviceRequest({
		url: `${baseUrl}/expert/member/status/change`,
		method: "post",
		data,
	});
};

export const inviteEXPERTProjectMember = (data) => {
	return serviceRequest({
		url: `${baseUrl}/expert/invite-member`,
		method: "post",
		data,
	});
};

export const getMemberInvitationiDetail = (params) => {
	return serviceRequest({
		url: `${baseUrl}/expert/member-invitation-detail`,
		method: "get",
		params,
	});
};

export const editEXPERTProject = (data) => {
	return serviceRequest({
		url: `${baseUrl}/expert/edit`,
		method: "post",
		data,
	});
};

export const getDareLicenseInfo = (data) => {
	return serviceRequest({
		url: `${baseUrl}/get-dare-license-info`,
		method: "post",
		data,
	});
};

export const releaseDareLicense = (data) => {
	return serviceRequest({
		url: `${baseUrl}/release-dare-license`,
		method: "post",
		data,
	});
};

export const notifyAccessEndEmail = (data) => {
	return serviceRequest({
		url: `${baseUrl}//access-end/email-notification`,
		method: "post",
		data,
	});
};
